import {axios} from 'marmot_design_ui'

import BaseData from './model/baseData'
// 集团业务上报接口
export const groupStatReport = (params: BaseData[]) => {
    return axios.request({
        url: '/leco/ecology/api/v1/stat/group/report',
        method: 'post',
        data: {data:params}
    })
}
// 租户业务上报接口
export const tenantStatReport = (params: BaseData[]) => {
    return axios.request({
        url: '/leco/ecology/api/v1/stat/tenant/report',
        method: 'post',
        data: {data:params}
    })
}